import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Container,
  Grid,
  Snackbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Edit, Delete, Add } from "@mui/icons-material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import axios from "axios";
import ExcludedZoneServices from "../services/externalServices/excludedZoneServices";

const ExcludedZone = () => {
  const [cityData, setCityData] = useState({
    city: "",
    restrictions: "",
    coordinates: [
      [
        { latitude: "", longitude: "" },
        { latitude: "", longitude: "" },
        { latitude: "", longitude: "" },
        { latitude: "", longitude: "" },
        { latitude: "", longitude: "" },
      ],
    ],
  });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [viewMode, setViewMode] = useState("Exclude Zones");
  const [excludedCity, setExcludedCity] = useState([]);
  const [editingCity, setEditingCity] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [cityToDelete, setCityToDelete] = useState(null);

  useEffect(() => {
    getExcludeZones();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCityData({ ...cityData, [name]: value });
  };

  const handleCoordinateChange = (rowIndex, columnIndex, key, value) => {
    const updatedCoordinates = [...cityData.coordinates];
    updatedCoordinates[rowIndex][columnIndex][key] = value;
    setCityData({ ...cityData, coordinates: updatedCoordinates });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (editingCity) {
        response = await ExcludedZoneServices.updateExcludedZone(editingCity._id, cityData);
      } else {
        response = await ExcludedZoneServices.addExcludeZone(cityData);
      }

     
        setSnackbarMessage("City operation successful");
        setSnackbarOpen(true);
        setCityData({
          city: "",
          restrictions: "",
          coordinates: [
            [
              { latitude: "", longitude: "" },
              { latitude: "", longitude: "" },
              { latitude: "", longitude: "" },
              { latitude: "", longitude: "" },
              { latitude: "", longitude: "" },
            ],
          ],
        });
        setViewMode("Exclude Zones");
        setEditingCity(null);
        getExcludeZones();
    
    } catch (error) {
      console.error("Error performing city operation:", error);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleCityValue = () => {
    setViewMode("Add the ExcludedZone");
  };

  const handleDeleteCity = async (id) => {
    try {
      const response = await ExcludedZoneServices.deleteExcludeZone(id);
     
        setExcludedCity((prevExcludedCity) =>
          prevExcludedCity.filter((city) => city._id !== id)
        );
        setSnackbarMessage("City deleted successfully");
        setSnackbarOpen(true);
    
        
    } catch (error) {
      console.error("Error deleting city:", error);
    }
  };

  const handleEditCity = (city) => {
    setEditingCity(city);
    setCityData({
      city: city.city,
      restrictions: city.restrictions,
      coordinates: city.coordinates,
    });
    setViewMode("Add the ExcludedZone");
  };

  const getExcludeZones = async () => {
    try {
      const result = await ExcludedZoneServices.getExcludedZones();
      setExcludedCity(result);
    } catch (err) {
      console.log("Error while getting the excluded city", err);
    }
  };

  const openDialog = (city) => {
    setCityToDelete(city);
    setDialogOpen(true);
  };

  const closeDialog = () => {
    setDialogOpen(false);
    setCityToDelete(null);
  };

  const confirmDeleteCity = () => {
    handleDeleteCity(cityToDelete._id);
    closeDialog();
  };

  return (
    <Box sx={{ width: "100%", marginTop: 5 }}>
      <nav>
        <ol className="breadcrumb d-none d-lg-flex ms-3">
          <li className="breadcrumb-item">
            <i className="bi bi-house lh-1"></i>
            <Link to="/dashboard" className="text-decoration-none" style={{ color: "#41505f" }}>
              Home
            </Link>
          </li>
          <li className="breadcrumb-item opacity-50">ExcludedCities</li>
        </ol>
      </nav>
      {viewMode === "Add the ExcludedZone" && (
        <Container>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={() => {
                setViewMode("Exclude Zones");
              }}
            >
              Back
            </Button>
          </Grid>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="City"
                  name="city"
                  value={cityData.city}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Restrictions"
                  name="restrictions"
                  value={cityData.restrictions}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">Coordinates</Typography>
                {cityData.coordinates.map((row, rowIndex) => (
                  <Grid container spacing={2} key={rowIndex}>
                    {row.map((coordinate, columnIndex) => (
                      <React.Fragment key={columnIndex}>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Latitude"
                            value={coordinate.latitude}
                            onChange={(e) =>
                              handleCoordinateChange(rowIndex, columnIndex, "latitude", e.target.value)
                            }
                            required
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Longitude"
                            value={coordinate.longitude}
                            onChange={(e) =>
                              handleCoordinateChange(rowIndex, columnIndex, "longitude", e.target.value)
                            }
                            required
                          />
                        </Grid>
                      </React.Fragment>
                    ))}
                  </Grid>
                ))}
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" color="primary">
                  {editingCity ? "Save Changes" : "Save"}
                </Button>
              </Grid>
            </Grid>
          </form>
          <Snackbar
            open={snackbarOpen}
            autoHideDuration={4000}
            onClose={handleCloseSnackbar}
            message={snackbarMessage}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          />
        </Container>
      )}
      {viewMode === "Exclude Zones" && excludedCity.length >= 1 && (
        <Container sx={{ marginTop: 5 }}>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="contained" color="primary" onClick={handleCityValue}>
              <Add />
            </Button>
          </Grid>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow sx={{ backgroundColor: "black" }}>
                  <TableCell>City</TableCell>
                  <TableCell>Restrictions</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {excludedCity.map((city) => (
                  <TableRow key={city._id} hover>
                    <TableCell>{city.city}</TableCell>
                    <TableCell>{city.restrictions}</TableCell>
                    <TableCell>
                      <span style={{ cursor: "pointer" }}>
                        <Edit
                          variant="contained"
                          color="primary"
                          onClick={() => handleEditCity(city)}
                        />
                      </span>
                    </TableCell>
                    <TableCell>
                      <span style={{ cursor: "pointer" }}>
                        <Delete
                          variant="contained"
                          color="danger"
                          onClick={() => openDialog(city)}
                        />
                      </span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      )}
      <Dialog
        open={dialogOpen}
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this city?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDeleteCity} color="primary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ExcludedZone;

// import React, { useEffect, useState } from "react";
// import {
//   TextField,
//   Button,
//   Typography,
//   Container,
//   Grid,
//   Snackbar,
// } from "@mui/material";
// import Tabs from "@mui/material/Tabs";
// import Tab from "@mui/material/Tab";
// import Box from "@mui/material/Box";
// import TableBody from "@mui/material/TableBody";
// import TableCell from "@mui/material/TableCell";
// import TableContainer from "@mui/material/TableContainer";
// import TableHead from "@mui/material/TableHead";
// import TableRow from "@mui/material/TableRow";
// import Table from "@mui/material/Table";
// import axios from "axios";
// import { Link } from "react-router-dom";
// const ExcludedZone = () => {
//   const [cityData, setCityData] = useState({
//     city: "",
//     restrictions: "",
//     coordinates: [
//       [
//         { latitude: "", longitude: "" },
//         { latitude: "", longitude: "" },
//         { latitude: "", longitude: "" },
//         { latitude: "", longitude: "" },
//         { latitude: "", longitude: "" },
//       ],
//     ],
//   });
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [value, setValue] = useState("Exclude Zones");
//   const [excludedCity, setExcludedCity] = useState([]);
//   const [editingCity, setEditingCity] = useState(null);

//   useEffect(() => {
//     getExcludeZones();
//   }, [value, excludedCity]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCityData({ ...cityData, [name]: value });
//   };

//   const handleCoordinateChange = (rowIndex, columnIndex, key, value) => {
//     const updatedCoordinates = [...cityData.coordinates];
//     updatedCoordinates[rowIndex][columnIndex][key] = value;
//     setCityData({ ...cityData, coordinates: updatedCoordinates });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       let response;
//       if (editingCity) {
//         response = await axios.put(
//           `http://localhost:8080/editingcity/${editingCity._id}`,
//           cityData
//         );
//       } else {
//         response = await fetch("http://localhost:8080/addExcludeZone", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(cityData),
//         });
//       }

//       if (response.status === 200 || response.status === 201) {
//         setSnackbarMessage("City operation successful");
//         setSnackbarOpen(true);
//         setCityData({
//           city: "",
//           restrictions: "",
//           coordinates: [
//             [
//               { latitude: "", longitude: "" },
//               { latitude: "", longitude: "" },
//               { latitude: "", longitude: "" },
//               { latitude: "", longitude: "" },
//               { latitude: "", longitude: "" },
//             ],
//           ],
//         });
//         setValue("Exclude Zones");
//         setEditingCity(null);
//       } else {
//         console.error("Failed to perform city operation");
//       }
//     } catch (error) {
//       console.error("Error performing city operation:", error);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbarOpen(false);
//   };

//   const handleCityValue = () => {
//     setValue("Add the ExcludedZone");
//   };

//   const handleDeleteCity = async (id) => {
//     try {
//       const response = await axios.delete(
//         `http://localhost:8080/deleteCity/${id}`
//       );

//       if (response.status === 200) {
//         setExcludedCity((prevExcludedCity) =>
//           prevExcludedCity.filter((city) => city._id !== id)
//         );
//         console.log("City deleted successfully");
//       } else {
//         console.error("Failed to delete city");
//       }
//     } catch (error) {
//       console.error("Error deleting city:", error);
//     }
//   };

//   const handleEditCity = (city) => {
//     setEditingCity(city);
//     setCityData({
//       city: city.city,
//       restrictions: city.restrictions,
//       coordinates: city.coordinates,
//     });
//     setValue("Add the ExcludedZone");
//   };

//   const getExcludeZones = async () => {
//     try {
//       const result = await axios.get("http://localhost:8080/getExcludeZones");
//       setExcludedCity(result.data);
//     } catch (err) {
//       console.log("error while getting the excluded city", err);
//     }
//   };

//   return (
//     <Box sx={{ width: "100%", marginTop:5 }}>
//       <nav>
//         <ol className="breadcrumb d-none d-lg-flex ms-3">
//           <li className="breadcrumb-item">
//             <i className="bi bi-house lh-1"></i>
//             <Link to="/dashboard" className="text-decoration-none" style={{ color: '#41505f' }}>Home</Link>
//           </li>
//           <li className="breadcrumb-item opacity-50">ExcludedCities</li>
//         </ol>
//       </nav>
//       {value === "Add the ExcludedZone" && (
//         <Container>
//              <Grid
//             item
//             xs={12}
//             sx={{ display: "flex", justifyContent: "flex-end" }}
//           >
//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               onClick={() => {
//                 setValue("Exclude Zones");
//               }}
//             >
//               back
//             </Button>
//           </Grid>
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="City"
//                   name="city"
//                   value={cityData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <TextField
//                   fullWidth
//                   label="Restrictions"
//                   name="restrictions"
//                   value={cityData.restrictions}
//                   onChange={handleChange}
//                   required
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography variant="h6">Coordinates</Typography>
//                 {cityData.coordinates.map((row, rowIndex) => (
//                   <Grid container spacing={2} key={rowIndex}>
//                     {row.map((coordinate, columnIndex) => (
//                       <React.Fragment key={columnIndex}>
//                         <Grid item xs={6}>
//                           <TextField
//                             fullWidth
//                             label="Latitude"
//                             value={coordinate.latitude}
//                             onChange={(e) =>
//                               handleCoordinateChange(
//                                 rowIndex,
//                                 columnIndex,
//                                 "latitude",
//                                 e.target.value
//                               )
//                             }
//                             required
//                           />
//                         </Grid>
//                         <Grid item xs={6}>
//                           <TextField
//                             fullWidth
//                             label="Longitude"
//                             value={coordinate.longitude}
//                             onChange={(e) =>
//                               handleCoordinateChange(
//                                 rowIndex,
//                                 columnIndex,
//                                 "longitude",
//                                 e.target.value
//                               )
//                             }
//                             required
//                           />
//                         </Grid>
//                       </React.Fragment>
//                     ))}
//                   </Grid>
//                 ))}
//               </Grid>
//               <Grid item xs={12}>
//                 <Button type="submit" variant="contained" color="primary">
//                   {editingCity ? "Update City" : "Add City"}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//           <Snackbar
//             open={snackbarOpen}
//             autoHideDuration={4000}
//             onClose={handleCloseSnackbar}
//             message={snackbarMessage}
//             anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//           />
//         </Container>
//       )}
//       {value === "Exclude Zones" && excludedCity.length >= 1 && (
//         <Container sx={{ marginTop: 5 }}>
//           <Grid
//             item
//             xs={12}
//             sx={{ display: "flex", justifyContent: "flex-end" }}
//           >
//             <Button
//               variant="contained"
//               color="primary"
//               onClick={handleCityValue}
//             >
//               Add City
//             </Button>
//           </Grid>
//           <TableContainer sx={{ maxHeight: 440 }}>
//             <Table stickyHeader aria-label="sticky table">
//               <TableHead>
//                 <TableRow sx={{ backgroundColor: "black" }}>
//                   <TableCell>City</TableCell>
//                   <TableCell>Restrictions</TableCell>
//                   <TableCell>Actions</TableCell>

//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {excludedCity.map((city) => (
//                   <TableRow key={city._id} hover>
//                     <TableCell>{city.city}</TableCell>
//                     <TableCell>{city.restrictions}</TableCell>
//                     <TableCell>
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         onClick={() => handleEditCity(city)}
//                       >
//                         Edit
//                       </Button>

//                       <Button
//                         variant="contained"
//                         color="secondary"
//                         onClick={() => handleDeleteCity(city._id)}
//                       >
//                         Delete
//                       </Button>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </Container>
//       )}
//     </Box>
//   );
// };

// export default ExcludedZone;
